<template>
    <iframe :src="pdf" frameborder="0" style="width: 100%;height: 100vh;display: block"></iframe>
</template>

<script>
export default {
  name: "lookPdf",
  data() {
    return {
      pdf: "static/pdf/web/viewer.html?file="
    }
  },
  mounted() {
    //this.$route.query.file
    setTimeout(()=>{
      this.getURL(this.$route.query.file)
    },10)
  },
  methods: {
    getURL(url) {
      this.$http({
        method: 'get',
        url: url,
        responseType: "blob"
      }).then((res) => {
        if (res.status == 200) {
          var blob = new Blob([res.data], {type: "application/pdf"}); // 文件流
          this.pdf += URL.createObjectURL(blob);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
